import script from "./usersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./usersPage.vue?vue&type=script&setup=true&lang=js"

import "./usersPage.vue?vue&type=style&index=0&id=c2258022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2258022"]])

export default __exports__